import './assets/styles/globals.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// レイアウト
import Header from './layout/Header';
import Footer from './layout/Footer';

// ページ
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProgramsPage from './pages/ProgramsPage';
import DonatePage from './pages/DonatePage';
import TokushoPage from './pages/TokushoPage';
import { NewsListPage, NewsDetailPage } from './pages/NewsPage';

// スクロール位置をリセット
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_SUSPENDED = false;

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function SuspendedNotice() {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: '#ffffff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 99999,
    }}>
      <p style={{
        fontFamily: "'HG丸ゴシックM-PRO', 'Hiragino Maru Gothic Pro', 'ヒラギノ丸ゴ Pro W4', sans-serif",
        color: '#4E342E',
        fontSize: '1.1rem',
        textAlign: 'center',
        lineHeight: 1.8,
        margin: 0,
        padding: '0 20px',
      }}>
        本サイトは現在一時停止中です。
      </p>
    </div>
  );
}

function App() {
  if (SITE_SUSPENDED) {
    return <SuspendedNotice />;
  }

  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/programs" element={<ProgramsPage />} />
        <Route path="/donate" element={<DonatePage />} />
        <Route path="/tokusho" element={<TokushoPage />} />
        <Route path="/news" element={<NewsListPage />} />
        <Route path="/news/:id" element={<NewsDetailPage />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
